import { createFileRoute } from '@tanstack/react-router';
import { AttendanceModule } from '@/modules/attendance';

export const Route = createFileRoute('/(dashboard)/_dashboard/attendance')({
  component: AttendanceModule,
});
